import React from "react";

import styles from "./YachtSetupHistory.module.scss";

export const LayoutContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.layoutContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);
